import { render, staticRenderFns } from "./UgiFileUploader.vue?vue&type=template&id=3205c1eb&scoped=true&"
import script from "./UgiFileUploader.vue?vue&type=script&lang=js&"
export * from "./UgiFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./UgiFileUploader.vue?vue&type=style&index=0&id=3205c1eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205c1eb",
  null
  
)

export default component.exports